export const stepOneData = [
  {
    heading: "Why Use Axis Bank Home Loan EMI Calculator?",
    // paras before heading

    infoList: [
      {
        heading: "Instant EMI Calculation: ",
        description: "Get an immediate estimate of your monthly repayment.",
      },
      {
        heading: "Easy-to-Use: ",
        description:
          "Axis Bank's EMI Calculator is user-friendly and free to use.",
      },
      {
        heading: "Flexible Loan Terms: ",
        description:
          "Explore how varying loan amounts and tenures affect your EMI.",
      },
      {
        heading: "Transparency: ",
        description:
          "Know your repayment obligations from day one with clear insights into principal and interest components.",
      },
    ],
  },
];

export const stepTwoData = [
  {
    heading: "Key Features of Axis Bank Home Loan EMI Calculator",

    tableContent: {
      heading: [
        {
          head: "Loan Type",
        },
        {
          head: "Interest Rate (Starting)",
        },
        {
          head: "Loan Tenure",
        },
        {
          head: "Processing Fees",
        },
      ],
      row: [
        {
          type: "Home Loan",
          interest: "8.60% p.a.",
          tenure: "Up to 30 years",
          fee: "₹10,000 (varies by loan amount)",
        },
      ],
    },
  },
];

export const stepThreeData = [
  {
    heading: "Factors Influencing Your EMI and Total Repayment",

    factorsList: [
      {
        heading: "Loan Amount: ",
        info: "Higher loan amounts will increase your EMI.",
      },
      {
        heading: "Interest Rate: ",
        info: "A higher interest rate results in a higher EMI and greater total repayment.",
      },
      {
        heading: "Loan Tenure: ",
        info: "Longer tenures will reduce your EMI but increase your overall interest payments.",
      },
      {
        heading: "Processing Fees: ",
        info: "The processing fees depend on the loan amount and terms. A higher loan amount might attract higher fees.",
      },
    ],
  },
];

export const stepFourData = [
  {
    heading: "How to Use Axis Bank Home EMI Calculator?",
    tableContent: {
      heading: [
        {
          head: "Loan Tenure",
        },
        {
          head: "Monthly EMI",
        },
        {
          head: "Interest Paid",
        },
        {
          head: "Total Repayment",
        },
      ],
      row: [
        {
          tenure: "5 years",
          emi: "Higher	",
          interest: "Lower",
          repayment: "Lower",
        },
        {
          tenure: "10 years	",
          emi: "Moderate",
          interest: "Moderate",
          repayment: "Moderate",
        },
        {
          tenure: "15 years",
          emi: "Lower	",
          interest: "Higher",
          repayment: "Higher",
        },
        {
          tenure: "20 years",
          emi: "Very Low	",
          interest: "Much Higher",
          repayment: "Much Higher",
        },
      ],
    },
  },
];

export const stepFiveData = [
  {
    heading: "Why Consider APR Over Just Interest Rates?",
  },
];

export const stepSixData = [
  {
    heading: "Axis Bank Home Loan EMI Breakdown",
    paraOne: "Your EMI consists of two main components:",
    infoList: [
      {
        head: "Principal: ",
        info: "The original loan amount you borrowed.",
      },
      {
        head: "Interest: ",
        info: "The fee charged by the bank for lending the money.",
      },
    ],
    paraTwo:
      "Early in the loan tenure, a larger portion of your EMI is allocated to the interest payment. As you continue making payments, the share of principal in your EMI gradually increases.",
  },
];

export const stepSevenData = [
  {
    heading: "MinEmi Tips for Borrowing from Axis Bank",
    infoList: [
      {
        head: "Negotiate Your Interest Rate: ",
        info: "If you have a good credit score (750+), you may be able to negotiate a lower interest rate.",
      },
      {
        head: "Select an Optimal Loan Tenure: ",
        info: "A long tenure means lower EMIs, but the total repayment amount increases. Choose a tenure that aligns with your budget.",
      },
      {
        head: "Prepayment and Part-Payment: ",
        info: "Axis Bank allows part-payments and prepayments. Use this option if you come into extra money to reduce your principal balance and save on interest.",
      },
      {
        head: "Monitor Your Credit Score: ",
        info: "A higher credit score might help in securing a lower interest rate. Keep track of your credit score to ensure you get the best rates available.",
      },
    ],
  },
];
